<template>
  <div class="incoming-call">
    <call-audio></call-audio>
    <div class="card" style="width: 18rem;">
      <img
        v-if="user"
        :src="`${staticUrl}${user.avatar}`"
        class="card-img-top"
        :alt="user.name"
      />
      <div class="card-body">
        <h5 class="card-title" v-if="user">{{ user.name }}</h5>
        <div class="row">
          <div class="col">
            <a href="#" class="btn btn-success" @click.prevent="answer(chatId)">
              <accept-call-icon></accept-call-icon>
              {{ $t("answer") }}
            </a>
          </div>
          <div class="col">
            <a href="#" class="btn btn-danger" @click.prevent="decline">
              <decline-call-icon></decline-call-icon>
              {{ $t("decline") }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
import AcceptCallIcon from '@/components/Icons/AcceptCall'
import DeclineCallIcon from '@/components/Icons/DeclineCall'
import CallAudio from '@/components/Audio/Call'
export default {
  components: {
    AcceptCallIcon,
    DeclineCallIcon,
    CallAudio
  },
  data () {
    return {
      user: null
    }
  },
  computed: {
    ...mapGetters({
      staticUrl: 'app/staticUrl',
      caller: 'call/callerId',
      chatId: 'call/chatId'
    })
  },
  mounted () {
    this.fetchUser(this.caller)
  },
  methods: {
    ...mapMutations({
      setError: 'alert/setError',
      decline: 'call/decline'
    }),
    ...mapActions({
      answer: 'call/initCall'
    }),
    async fetchUser (id) {
      try {
        const params = { ids: [id] }
        const response = await this.axios.post('/api/users', params)
        const user = response.data.data[0]
        this.user = {
          id: user.id,
          name: `${user.firstname.ka} ${user.lastname.ka}`,
          avatar: user.photo
        }
      } catch (err) {
        this.setError(err)
      }
    }
  }
}
</script>
<style lang="scss">
.incoming-call {
  position: absolute;
  z-index: 1111101;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  .card {
    margin: auto;
    .btn {
      svg {
        width: 48px;
        height: 48px;
      }
    }
  }
}
</style>
<i18n>
{
  "ka": {
      "answer": "პასუხი",
      "decline": "უარყოფა"
  },
  "ka": {
      "answer": "Answer",
      "decline": "Decline"
  }
}
</i18n>
